<template>
	<div class="order-details">
		<div class="header bg-color-red acea-row row-middle">
		  <!-- <div class="pictrue">
		    <img :src="orderInfo.status_pic" />
		  </div> -->
		  <div class="data">
		    <div class="state">{{ orderInfo._status._msg }}</div>
		    <div>
		      {{ orderInfo.add_time_y}}<span class="time">{{ orderInfo.add_time_h }}</span>
		    </div>
		  </div>
		</div>
		<OrderGoods :evaluate="status.type || 0" :cartInfo="orderInfo.cartInfo || []" :scan="0"></OrderGoods>
		<div class="wrapper">
			<div class="item acea-row row-between">
				<div>订单编号：</div>
				<div class="conter acea-row row-middle row-right">
					{{ orderInfo.order_id }}
					<span class="copy copy-data" :data-clipboard-text="orderInfo.order_id">复制</span>
				</div>
			</div>
			<div class="item acea-row row-between">
				<div>下单时间：</div>
				<div class="conter">
					{{ orderInfo.add_time_y + " " + orderInfo.add_time_h }}
				</div>
			</div>
			<div class="item acea-row row-between">
				<div>订单类型：</div>
				<div class="conter">{{ orderTypeName }}</div>
			</div>
			<div class="item acea-row row-between">
				<div>支付状态：</div>
				<div class="conter">{{ orderInfo.paid ? "已支付" : "未支付" }}</div>
			</div>
			<div class="item acea-row row-between">
				<div>支付方式：</div>
				<div class="conter">{{ orderInfo._status._payType }}</div>
			</div>
			<div class="item acea-row row-between" v-if="orderInfo.mark">
				<div>买家留言：</div>
				<div class="conter">{{ orderInfo.mark }}</div>
			</div>
		</div>
		<div class="wrapper">
			<div class="item acea-row row-between" v-if="orderInfo.total_vip_price > 0 && orderInfo.bargain_id == 0 && orderInfo.combination_id == 0 && orderInfo.seckill_id == 0">
				<div>优惠金额：</div>
				<div class="conter">-￥{{ orderInfo.total_vip_price }}</div>
			</div>
			<div class="item acea-row row-between">
				<div>支付金额：</div>
				<div class="conter">￥{{ orderInfo.total_price }}</div>
			</div>
			<div class="actualPay acea-row row-right">
				实付款：<span class="money font-color-red">￥{{ orderInfo.pay_price }}</span>
			</div>
		</div>
		<div style="height:1.2rem;" v-if="!refundOrder && offlineStatus"></div>
		<div class="footer acea-row row-right row-middle" v-if="!refundOrder && offlineStatus">
			<!-- <div
			  class="bnt sign"
			  v-if="orderInfo.is_contract"
			  @click="$router.push({ path: '/order/sign/' + orderInfo.order_id })"
			>
			  查看合同
			</div> -->
			<template v-if="status.type === 0">
				<div class="bnt cancel" @click="cancelOrder">取消订单</div>
				<div class="bnt bg-color-red" @click="pay = true">立即付款</div>
			</template>
			<template v-if="(status.type === 1 || status.type === 2 || status.type === 3 || status.type === 4 || status.type === 6) && isShowButton.refund">
				<div
				  v-if="orderInfo.paid === 1 && orderInfo.refund_status === 0 &&  status.refund_type"
				  class="bnt bg-color-red"
				  @click="ApplyRefund()"
				>操作退款</div>
			</template>
			<template v-if="isShowButton.verific && status.type === 1 && orderInfo.paid === 1 && orderInfo.refund_status === 0">
				<div class="bnt bg-color-red" @click="Verific()">核销订单</div>
			</template>
			<div class="refund-mask mask" v-if="isRefundMask">
				<div class="refund-Popup">
					<div class="refund-Popup-title">申请退款</div>
					<div class="refund-radio" v-if="refund_info.typeinfo.length > 0">
						<div class="refund-radio-for" v-for="(item,key) in refund_info.typeinfo">
							<input
							  type="radio"
							  name="scan_refund_type"
							  :value="item.value"
							  :id="'type_'+item.value"
							  :checked="item.is_default"
							  @change="radioChange(item.value)"
							>
							<label :for="'type_'+item.value"></label>
							<span>{{ item.label }}</span>
						</div>
					</div>
					<div class="refund-price">
						退款金额：<input type="number" @blur="radioBlur()" v-model="refund_price" :disabled="isPrice" >
					</div>
					<div class="refund-btn-wapper">
						<button class="refund-btn" @click="SubmitRefund()">提交</button>
						<button
						  class="refund-btn cancel"
						  @click="isRefundMask = false; isPrice = true;"
						>取消</button>
					</div>
				</div>
			</div>
		</div>
		<Payment v-model="pay" :types="payType" @checked="toPay" :balance="userInfo.now_money"></Payment>
		
		<GeneralWindow :generalActive="generalActive" @closeGeneralWindow="closeGeneralWindow" :generalContent="generalContent"></GeneralWindow>
	</div>
</template>

<script>
import OrderGoods from "@components/OrderGoods";
import { cashierOrderDetail, cashierOrderScan, cashierRefundInfo, cashierRefund, cashierVerific, cashierOrderCancel } from "@api/order";
import { VUE_APP_API_URL } from "@utils";
import VueCoreImageUpload from "vue-core-image-upload";
import ClipboardJS from "clipboard";
import Payment from "@components/Payment";

import { mapGetters } from "vuex";
import {
	cancelOrderHandle,
	takeOrderHandle,
	delOrderHandle,
	payOrderHandle
} from "@libs/order";
import { wechatEvevt } from "@libs/wechat";
import GeneralWindow from "@components/GeneralWindow";
const NAME = "ScanOrderDerails";
export default {
	name: NAME,
	components: {
		OrderGoods,
		Payment,
		GeneralWindow,
		VueCoreImageUpload
	},
	props: {},
	data: function() {
		return {
			offlinePayStatus: 2,
			orderTypeName: "门店订单",
			orderTypeNameStatus: true,
			offlineStatus: true,
			id: this.$route.params.orderid,
			uid: this.$route.query.uid,
			orderInfo: {
				_status: {}
			},
			isShowButton: {},//判断退款和核销按钮
			status: {},
			pay: false,
			payType: ["weixin", "alipay", "offline"],
			from: this.$wechat.isWeixin() ? "weixin" : "weixinh5",
			mapKay: "",
			mapShow: false,
			generalActive: false,
			generalContent: {
				promoterNum: "",
				title: ""
			},
			imglist: [],
			imgshow: false,
			beforeshow: false,
			closeshow: true,
			url: `${VUE_APP_API_URL}/upload/image/` + this.$route.params.orderid,
			headers: {
				"Authori-zation": "Bearer " + this.$store.state.app.token
			},
			// 退款弹窗
			isRefundMask: false,
			refund_info: {},
			scan_refund_type: 1,
			refund_price: "",
			fixed_price: "",
			isPrice: true
		};
	},
	computed: {
		refundOrder() {
			return this.orderInfo.refund_status > 0;
		},
		...mapGetters(["userInfo"])
	},
	watch: {
		$route(n) {
			if (n.name === NAME && this.id !== n.params.orderid) {
				this.id = n.params.orderid;
				this.uid = n.query.uid;
				this.getDetail();
			}
		}
	},
	inject: ["app"],
	mounted: function() {
		this.getDetail();
		this.$nextTick(function() {
			let copybtn = document.getElementsByClassName("copy-data");
			const clipboard = new ClipboardJS(copybtn);
			clipboard.on("success", () => {
				this.$dialog.success("复制成功");
			});
		});
	},
	methods: {
		closeGeneralWindow(msg) {
			this.generalActive = msg;
			this.getDetail();
		},
		goBack() {
			const history = this.app.history,
				last = history[history.length - 1] || {};
			if (last.name === "MyOrder") return this.$router.go(-1);
			else return this.$router.replace({
				path: "/order/list/"
			});
		},
		cancelOrder() {
			let that = this,
			  data = {
				order_id: that.id,
				uid: that.uid
			  };
			that.$dialog.confirm({
			  mes: "确认取消吗？",
			  opts: [
				{
				  txt: "取消",
				  color: false
				},
			    {
			      txt: "确认",
			      color: true,
			      callback: () => {
					that.$dialog.loading.open("加载中");
					cashierOrderCancel(data).then(res => {
						that.$dialog.loading.close();
						that.$dialog.success(res.msg);
						that.$router.replace('/user/scan_order/999');
					}).catch(err => {
						that.$dialog.loading.close();
						that.$dialog.error(err.msg);
					});
			      }
			    }
			  ]
			});
		},
		delOrder() {
			delOrderHandle(this.orderInfo.order_id).then(() => {
				setTimeout(() => this.goBack(), 300);
			});
		},
		setOfflinePayStatus: function(status) {
			var that = this;
			that.offlinePayStatus = status;
			if (status === 1 && that.orderTypeNameStatus === true) {
				that.payType.push("offline");
			}
		},
		getOrderStatus: function() {
			let orderInfo = this.orderInfo || {},
				_status = orderInfo._status || {
					_type: 0
				},
				status = {};
			let type = parseInt(_status._type),
				refund_type = _status._refund_type,
				delivery_type = orderInfo.delivery_type,
				seckill_id = orderInfo.seckill_id ? orderInfo.seckill_id : 0,
				bargain_id = orderInfo.bargain_id ? parseInt(orderInfo.bargain_id) : 0,
				combination_id = orderInfo.combination_id ?
				parseInt(orderInfo.combination_id) :
				0;
			status = {
				type: type,
				refund_type: refund_type,
				class_status: 0
			};
			if (type === 1 && combination_id > 0) {
				status.type = 6;
				status.class_status = 1;
			} //查看拼团
			if (type === 2 && delivery_type === "express") status.class_status = 2; //查看物流
			if (type === 2) status.class_status = 3; //确认收货
			if (type === 4 || type === 0) status.class_status = 4; //删除订单
			if (
				!seckill_id &&
				!bargain_id &&
				!combination_id &&
				(type === 3 || type === 4)
			)
				status.class_status = 5; //再次购买
			if (type == 9) {
				//线下付款
				status.class_status = 0;
				this.offlineStatus = false;
			}
			this.status = status;
		},
		getDetail() {
			let that = this;
			const orderid = that.id,
			  uid = that.uid;
			cashierOrderDetail(orderid, uid).then(res => {
				that.orderInfo = res.data;
				that.isShowButton = res.data.buttont;
				this.getOrderStatus();
				this.setOfflinePayStatus(this.orderInfo.offlinePayStatus);
				this.$nextTick(function() {
					let copybtn = document.getElementsByClassName("copy-data");
					const clipboard = new ClipboardJS(copybtn);
					clipboard.on("success", () => {
						this.$dialog.success("复制成功");
					});
				});
			})
			.catch(err => {
				this.$dialog.error(err.msg);
				// this.$router.go(-1);
			});
		},
		async toPay(type) {
			var that = this,
			  data = {
				  uid: that.uid,
				  uni: that.id,
				  paytype: type
			  };
			await cashierOrderScan(data).then(res => {
				var data = res.data;
				switch (data.status) {
					case "ORDER_EXIST":
					case "EXTEND_ORDER":
					case "PAY_DEFICIENCY":
					case "PAY_ERROR":
					  that.$dialog.toast({ mes: res.msg });
					  break;
					case "SUCCESS":
					  that.$dialog.success(res.msg);
					  break;
					case "WECHAT_PAY":
					case "ALIPAY_H5_PAY":
					  that.$router.push('/user/pay_code/' + that.id + '/' + data.result.uid + '?code_url=' + data.result.code_url);		  
					  break;
				}
			}).catch(err => {
				that.$dialog.error(err.msg);
			});
			that.getDetail();
		},
		//申请退款
		ApplyRefund(){
			let that = this;
			cashierRefundInfo(that.id).then(res => {
				that.isRefundMask = true;
				that.refund_info = res.data;
				that.refund_price = res.data.refund_price;
				that.fixed_price = res.data.refund_price;
			}).catch(err => {
				that.$dialog.error(err.msg);
			});
		},
		radioChange(type){
			console.log(type);
			if(type == 2){
				this.isPrice = false;
				this.scan_refund_type = 2;
			}else{
				this.isPrice = true;
				this.scan_refund_type = 1;
				this.refund_price = this.fixed_price;
			}
		},
		radioBlur(){
			document.body.scrollTop = 0;
		},
		//提交退款
		SubmitRefund(){
			let that = this,
			  data = {
				  order_id: that.id,
				  price: that.refund_price,
				  type : that.scan_refund_type
			  };
			that.$dialog.confirm({
			  mes: "确认退款吗？",
			  opts: [
				{
				  txt: "取消",
				  color: false
				},
			    {
			      txt: "确认",
			      color: true,
			      callback: () => {
					that.isRefundMask = false;
					that.isPrice = true;
					that.$dialog.loading.open("加载中");
			        cashierRefund(data).then(res => {
						that.$dialog.loading.close();
			        	that.$dialog.success(res.msg);
			        	that.$router.replace('/user/scan_order/999');
			        }).catch(err => {
						that.$dialog.loading.close();
						that.isPrice = true;
			        	that.$dialog.error(err.msg);
			        });
			      }
			    }
			  ]
			});
		},
		//核销订单
		Verific(){
			let that = this,
			  data = {
				  order_id: that.id
			  };
			that.$dialog.confirm({
			  mes: "确认核销吗？",
			  opts: [
				{
				  txt: "取消",
				  color: false
				},
			    {
			      txt: "确认",
			      color: true,
			      callback: () => {
					that.$dialog.loading.open("加载中");
					cashierVerific(data).then(res => {
						that.$dialog.loading.close();
						that.$dialog.success(res.msg);
						that.getDetail();
					}).catch(err => {
						that.$dialog.loading.close();
						that.$dialog.error(err.msg);
					});
			      }
			    }
			  ]
			});
		}
	}
};
</script>
<style scoped>
.order-details .header .data{
	margin-left: 0;
}
.pictrue1 {
	width: 2rem;
	height: 2rem;
	border: 1px solid #ddd;
	margin-top: 0.15rem;
	position: relative;
	float: left;
	margin-left: 0.3rem;
}
.imgbox {
	width: 1.95rem;
	height: 1.95rem;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	justify-content: center;
}
.pictrue1 img {
	display: block;
	width: 100%;
}
.closeimg {
	position: absolute;
	top: -10%;
	right: -18%;
}
.mask {
	width: 100%;
	height: 100%;
	background: rgba(0,0,0,0.5);
	display: flex;
	justify-content: center;
	align-items: center;
}
.mask img {
	width: 100%;
	display: block;
}
.refund-Popup{
	background-color: #fff;
	width: 80%;
	border-radius: 8px;
}
.refund-Popup-title{
	height: 1rem;
	line-height: 1rem;
	text-align: center;
	border-bottom: 1px solid #ccc;
	font-weight: bold;
	font-size: 0.3rem;
}
.refund-radio{
	padding: 0.2rem;
	display: flex;
	justify-content: center;
	align-items: center;
}
.refund-radio-for{
	position: relative;
	width: 38%;
}
.refund-radio-for span{
	position: absolute;
	left: 0.4rem;
	top: 0.01rem;
	width: 1.5rem;
}
input[type="radio"] {
	width: 0.3rem;
	height: 0.3rem;
	opacity: 0;
}
label {
	position: absolute;
	left: 0;
	top: 0.06rem;
	width: 0.3rem;
	height: 0.3rem;
	border-radius: 50%;
	border: 1px solid #999;
	cursor: pointer;
	display: inline-block;
	margin-right: 0.1rem;
}
input[type="radio"]:checked+label { 
	background-color: #e93323;
	border: 1px solid #e93323;
}
input[type="radio"]:checked+label::after {
	position: absolute;
	content: "";
	width: 0.09rem;
	height: 0.17rem;
	top: 0.02rem;
	left: 0.09rem;
	border: 2px solid #fff;
	border-top: none;
	border-left: none;
	transform: rotate(45deg);
}
.refund-price{
	padding: 0 0.2rem;
	display: flex;
	justify-content: center;
	align-items: center;
}
.refund-price input{
	border: 1px solid #ccc;
	text-indent: 0.2rem;
}
.refund-btn-wapper{
	margin: 0.3rem auto;
	margin-top: 0.5rem;
	display: flex;
	justify-content: center;
	align-items: center;
}
.refund-btn{
	padding: 0.1rem 0.5rem;
	background-color: #e93323;
	color: #fff;
	border-radius: 7px;
	border: 1px solid #e93323;
}
.refund-btn-wapper .cancel{
	margin-left: 0.6rem;
	background-color: #fff;
	color: #e93323;
}
div.img_close {
	width: 16px;
	height: 16px;
	position: absolute;
	top: -7px;
	right: -7px;
	background: #d9d9d9;
	color: #fff;
	text-align: center;
	line-height: 14px;
	border-radius: 50%;
	transform: rotate(45deg);
	-webkit-transform: rotate(45deg);
	-moz-transform: rotate(45deg);
}
.iconfont {
	margin-right: 0.15rem;
}
.order-details .map {
	height: 0.86rem;
	font-size: 0.3rem;
	color: #282828;
	line-height: 0.86rem;
	border-bottom: 0.01rem solid #f0f0f0;
	margin-top: 0.13rem;
	background-color: #fff;
	padding: 0 0.3rem;
}
.order-details .map .place {
	font-size: 0.26rem;
	width: 1.76rem;
	height: 0.5rem;
	border-radius: 0.25rem;
	line-height: 0.5rem;
	text-align: center;
}
.order-details .map .place .iconfont {
	font-size: 0.27rem;
	height: 0.27rem;
	line-height: 0.27rem;
	margin: 0.02rem 0.03rem 0 0;
}
.order-details .address .name .iconfont {
	font-size: 0.34rem;
	margin-left: 0.1rem;
}
.sign {
	color: #F21B07 !important;
	border: 1px solid #F21B07;
}
</style>
